module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('md-toolbar', {
    attrs: {
      "id": "toolbar"
    }
  }, [(_vm.currentPage != 'about') ? _c('md-button', {
    staticClass: "md-icon-button smaller-screen-display",
    on: {
      "click": _vm.toggleLeftSidenav
    }
  }, [_c('md-icon', [_vm._v("menu")])], 1) : _vm._e(), _vm._v(" "), _c('h2', {
    staticClass: "md-title",
    staticStyle: {
      "flex": "1"
    }
  }, [_vm._v("Najdi Zobozdravnika")]), _vm._v(" "), _c('div', {
    staticClass: "router-link-wrapper"
  }, [_c('router-link', {
    attrs: {
      "tag": "md-button",
      "to": "/"
    }
  }, [_vm._v("Domov")]), _vm._v(" "), (_vm.currentPage != 'about') ? _c('md-button', {
    staticClass: "larger-screen-display",
    on: {
      "click": _vm.toggleLeftSidenav
    }
  }, [_vm._v("Filtri")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "md-button",
      "to": "/about/"
    }
  }, [_vm._v("O strani")])], 1)], 1), _vm._v(" "), _c('md-sidenav', {
    ref: "leftSidenav",
    staticClass: "md-left",
    on: {
      "open": function($event) {
        _vm.open('Left')
      },
      "close": function($event) {
        _vm.close('Left')
      }
    }
  }, [_c('md-toolbar', {
    staticClass: "md-small sidenav"
  }, [_c('div', {
    staticClass: "md-toolbar-container"
  }, [_c('h3', {
    staticClass: "md-title"
  }, [_vm._v("Filtri")]), _vm._v(" "), _c('md-button', {
    on: {
      "click": _vm.toggleLeftSidenav
    }
  }, [_c('md-icon', [_vm._v("arrow_back")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "side-filter"
  }, [_c('div', {
    staticClass: "description"
  }, [_vm._v("\n                Tip zobozdravnika:\n            ")]), _vm._v(" "), _c('md-button-toggle', [_c('md-button', {
    staticClass: "md-icon-button",
    attrs: {
      "id": "child"
    },
    on: {
      "click": function($event) {
        _vm.toggleType(0)
      }
    }
  }, [_c('md-icon', [_vm._v("child_care")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "left"
    }
  }, [_vm._v("za mladino")])], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button",
    attrs: {
      "id": "adult"
    },
    on: {
      "click": function($event) {
        _vm.toggleType(1)
      }
    }
  }, [_c('md-icon', [_vm._v("face")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "right"
    }
  }, [_vm._v("za odrasle")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "side-filter"
  }, [_c('div', {
    staticClass: "description OE-position"
  }, [_vm._v("\n                Območna Enota:\n            ")]), _vm._v(" "), _c('ul', [_c('li', [_c('md-checkbox', {
    staticClass: "md-primary",
    attrs: {
      "id": "all-sidenav",
      "name": "all-sidenav"
    },
    on: {
      "change": _vm.selectAll
    },
    model: {
      value: (_vm.allSelected),
      callback: function($$v) {
        _vm.allSelected = $$v
      },
      expression: "allSelected"
    }
  }, [_vm._v("Izberi vse")])], 1), _vm._v(" "), _vm._l((_vm.OE), function(item) {
    return (!_vm.allSelected) ? _c('li', [_c('md-checkbox', {
      attrs: {
        "id": item.id,
        "value": item.id
      },
      on: {
        "change": function($event) {
          _vm.select(item.id)
        }
      },
      model: {
        value: (item.checked),
        callback: function($$v) {
          item.checked = $$v
        },
        expression: "item.checked"
      }
    }, [_vm._v(_vm._s(item.name))])], 1) : _vm._e()
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "side-filter"
  }, [_c('div', {
    staticClass: "description"
  }, [_vm._v("\n                Max povprečja:\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.maxAverage),
      expression: "maxAverage"
    }],
    staticClass: "number-input",
    attrs: {
      "type": "text",
      "maxlength": "3"
    },
    domProps: {
      "value": (_vm.maxAverage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.maxAverage = $event.target.value
      }
    }
  }), _vm._v(" %\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "side-filter"
  }, [_c('div', {
    staticClass: "description sort-by"
  }, [_vm._v("\n                Razvrsti po:\n            ")]), _vm._v(" "), _c('ul', [_c('li', [_c('md-radio', {
    attrs: {
      "id": "filter-by-surname",
      "name": "",
      "md-value": "priimek_in_ime_zdravnika"
    },
    model: {
      value: (_vm.sortBy),
      callback: function($$v) {
        _vm.sortBy = $$v
      },
      expression: "sortBy"
    }
  }, [_vm._v("Priimku")])], 1), _vm._v(" "), _c('li', [_c('md-radio', {
    attrs: {
      "id": "filter-by-place",
      "name": "my-test-group1",
      "md-value": "naslov_izvajalca_drugi_del"
    },
    model: {
      value: (_vm.sortBy),
      callback: function($$v) {
        _vm.sortBy = $$v
      },
      expression: "sortBy"
    }
  }, [_vm._v("Kraju")])], 1), _vm._v(" "), _c('li', [_c('md-radio', {
    attrs: {
      "id": "filter-by-average",
      "name": "my-test-group1",
      "md-value": "doseganje_povprecja"
    },
    model: {
      value: (_vm.sortBy),
      callback: function($$v) {
        _vm.sortBy = $$v
      },
      expression: "sortBy"
    }
  }, [_vm._v("Doseganju Povprečja")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "side-filter"
  }, [_c('div', {
    staticClass: "description"
  }, [_vm._v("\n                Tip razvrstitve:\n            ")]), _vm._v(" "), _c('md-button-toggle', {
    attrs: {
      "md-single": ""
    }
  }, [_c('md-button', {
    staticClass: "md-icon-button md-toggle",
    on: {
      "click": function($event) {
        _vm.ascOrDesc = 'ASC'
      }
    }
  }, [_c('md-icon', [_vm._v("arrow_upward")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "left"
    }
  }, [_vm._v("Naraščujoče")])], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": function($event) {
        _vm.ascOrDesc = 'DESC'
      }
    }
  }, [_c('md-icon', [_vm._v("arrow_downward")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "left"
    }
  }, [_vm._v("Padajoče")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "filter-button-wrapper"
  }, [_c('md-button', {
    on: {
      "click": _vm.defaultSettings
    }
  }, [_vm._v("Ponastavi filtre")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised",
    on: {
      "click": function($event) {
        _vm.createHTTPGETparameters();
        _vm.toggleLeftSidenav()
      }
    }
  }, [_vm._v("Filtriraj")]), _vm._v(" "), _c('md-button', {
    on: {
      "click": _vm.toggleLeftSidenav
    }
  }, [_c('md-icon', [_vm._v("arrow_back")])], 1)], 1)], 1), _vm._v(" "), (_vm.loadingDataState) ? _c('loading-screen', {
    attrs: {
      "errorInLoadingData": _vm.errorInLoadingData
    },
    on: {
      "tryAgainEvent": _vm.tryAgain
    }
  }) : _vm._e(), _vm._v(" "), (_vm.cookieWarningShow) ? _c('cookie-warning', {
    staticClass: "cookie-warning-position",
    on: {
      "allowCookiesEvent": _vm.allowCookies
    }
  }) : _vm._e(), _vm._v(" "), _c('router-view', {
    attrs: {
      "HTTPGETparameters": _vm.HTTPGETparameters,
      "tryAgainState": _vm.tryAgainState
    },
    on: {
      "loadingDataEvent": _vm.loadingData,
      "loadingDataErrorEvent": _vm.loadingDataError
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34465cd9","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 68
// module chunks = 0